"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var replace_variable_1 = require("./replace-variable");
var replace_defined_variables_1 = require("./replace-defined-variables");
exports.replaceVariables = ramda_1.curry(function (variables, html) {
    var replacedHtml = replace_defined_variables_1.replaceDefinedVariables(variables, html);
    return replaceUndefinedVariables(replacedHtml);
});
function replaceUndefinedVariables(html) {
    return replace_variable_1.replaceVariable(html, '', '.+?');
}
//# sourceMappingURL=replace-variables.js.map